import React, { useState } from "react";
import { FiArrowUpCircle } from "react-icons/fi";
import styles from "../../styles/AccountBilling/Subscription.module.css"
const Subscription = () => {
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({
        ActivePlan: "Premium plan",
        BrandWorkspace: "2",
        ActiveSince: '2025',
        BrandWorkspacesUsed: "1/2",
        UsersUsed: "2/10",  
        PostsPerMonth: "100/Unlimited",
    });

    const handleEditClick = () => {
        setIsEditing(true);
    };

    const handleSaveClick = () => {
        setIsEditing(false);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    return (
        <div class="company-management-card">
            <div className={styles.detailsHeader}>
                <span className={styles.detailsHeading} >Subscription</span>
                {!isEditing ? (
                    <button className={styles.editBtn} onClick={handleEditClick}>
                         <FiArrowUpCircle /> Upgrade plan
                    </button>
                ) : (
                    <button className={styles.saveBtn} onClick={handleSaveClick}>
                        Save
                    </button>
                )}
            </div>
            <div className="separator"/>
            <div className={styles.detailsContent}>
                <div className={styles.detailItem}>
                    <span className={styles.detailLabel}>Active plan</span>
                    {isEditing ? (
                        <input
                            type="text"
                            name="ActivePlan"
                            value={formData.ActivePlan}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{formData.ActivePlan}</p>
                    )}
                </div>

                <div className={styles.detailItem}>
                    <span className={styles.detailLabel}>Brand Workspace</span>
                    {isEditing ? (
                        <input
                            type="text"
                            name="BrandWorkspace"
                            value={formData.BrandWorkspace}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{formData.BrandWorkspace}</p>
                    )}
                </div>
                <div className={styles.detailItem}>
                    <span className={styles.detailLabel}>Active Since</span>
                    {isEditing ? (
                        <input
                            type="text"
                            name="ActiveSince"
                            value={formData.ActiveSince}
                            onChange={handleChange}
                        />
                    ) : (
                        <p>{formData.ActiveSince}</p>
                    )}
                </div>
                {/* Plan Details Section */}
                <div className={styles.detailItem}>
                    <span className={styles.detailLabel}>Plan Details</span>
                    <div className={styles.planDetailsGrid}>
                        <div className={styles.planDetailRow}>
                            <span>Brand Workspaces</span>
                            {isEditing ? (
                                <input
                                    type="text"
                                    name="BrandWorkspacesUsed"
                                    value={formData.BrandWorkspacesUsed}
                                    onChange={handleChange}
                                />
                            ) : (
                                <span>{formData.BrandWorkspacesUsed}</span>
                            )}
                        </div>

                        <div className={styles.planDetailRow}>
                            <span>Users</span>
                            {isEditing ? (
                                <input
                                    type="text"
                                    name="UsersUsed"
                                    value={formData.UsersUsed}
                                    onChange={handleChange}
                                />
                            ) : (
                                <span>{formData.UsersUsed}</span>
                            )}
                        </div>

                        <div className={styles.planDetailRow}>
                            <span>Post per month</span>
                            {isEditing ? (
                                <input
                                    type="text"
                                    name="PostsPerMonth"
                                    value={formData.PostsPerMonth}
                                    onChange={handleChange}
                                />
                            ) : (
                                <span>{formData.PostsPerMonth}</span>
                            )}
                        </div>
                    </div>
                </div>
                <br></br>
                <br></br>
                <br></br>
                <br></br>
            </div>
        </div>
    );
};

export default Subscription;